import { Pipe, PipeTransform } from '@angular/core';
import { ActivityTypes } from '../../app/models/domain/activity.item';


@Pipe({ name: 'getActivityType' })
export class ActivityTypePipe implements PipeTransform {

    transform(value: ActivityTypes): string {

        switch ( value ) {
            case ActivityTypes.AdminLogItem:
                return 'Admin Log';
            case ActivityTypes.MemberLogItem:
                return 'Member Activity Log';
            case ActivityTypes.Email:
                return 'Email';
            case ActivityTypes.Note:
                return 'Note';
            case ActivityTypes.Ticket:
                return 'Ticket';
            case ActivityTypes.FileUpload:
                return 'File Upload';
            default:
                return 'No Type'
        }

    }

}
